import { fromRefinement } from 'io-ts/Decoder';

/**
 * Six-digit hex colour string (e.g. `#FF0033`). Validated at the wire boundary
 * so we never persist anything that downstream renderers (PixiJS, node-canvas,
 * PDF) cannot consume — and so style attributes like `backgroundColor: color`
 * or PDF SVG `fill` cannot be hijacked with arbitrary strings.
 */
const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export const HexColor = fromRefinement(
	(input: unknown): input is string => typeof input === 'string' && HEX_COLOR_REGEX.test(input),
	'HexColor (#RRGGBB)'
);
